import { Box, Card, Stack, Text, Title } from '@mantine/core';
import { IconClipboardList } from '@tabler/icons-react';

export function ClientPortalRequestStatusPage(): JSX.Element {
  // TODO: Query ServiceRequest?subject=Patient/{id}&category=service-request
  return (
    <Box p="md">
      <Stack gap="lg">
        <Title order={3}>My Service Requests</Title>
        <Card withBorder p="xl" style={{ textAlign: 'center' }}>
          <Stack align="center" gap="md">
            <IconClipboardList size={48} stroke={1.5} color="var(--mantine-color-gray-5)" />
            <Text size="lg" fw={500}>No active requests</Text>
            <Text size="sm" c="dimmed">
              When you submit a service request, its status will appear here.
            </Text>
          </Stack>
        </Card>
      </Stack>
    </Box>
  );
}
